export function sortOrdersByDeparture(orders, direction = "asc") {
  return [...orders].sort((a, b) => {
    if (!a.departure_date || !b.departure_date) return a.departure_date ? -1 : b.departure_date ? 1 : 0;
    const key = order => `${order.departure_date}T${String(order.pickup_time || "00:00").padStart(5, "0")}`;
    const comparison = key(a).localeCompare(key(b));
    return direction === "desc" ? -comparison : comparison;
  });
}
